import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';

export const UITitleLineShape = {
  text: isRequiredIf(PropTypes.string, (props) => props.type === 'UITitleLine'),
  color: isRequiredIf(
    PropTypes.shape({
      hex: PropTypes.string.isRequired,
    }),
    (props) => props.type === 'UISpanText' || props.type === 'UISpanIcon',
  ),
  truncate: PropTypes.bool,
};

export const UITitleLineProps = {
  truncate: false,
};

export const UITextLineShape = {
  uiSpans: isRequiredIf(
    PropTypes.arrayOf(
      PropTypes.shape({
        typeName: PropTypes.string.isRequired,
        text: isRequiredIf(PropTypes.string, (props) => props.type === 'UISpanText'),
        width: isRequiredIf(PropTypes.string, (props) => props.type === 'UISpanSpacer'),
        icon: isRequiredIf(
          PropTypes.shape({
            name: PropTypes.string.isRequired,
            image: PropTypes.string,
          }),
          (props) => props.type === 'UISpanIcon',
        ),
        color: isRequiredIf(
          PropTypes.shape({
            hex: PropTypes.string.isRequired,
          }),
          (props) => props.type === 'UISpanText' || props.type === 'UISpanIcon',
        ),
      }),
    ),
    (props) => props.type === 'UITextLine',
  ),
  truncate: PropTypes.bool,
  withPadding: PropTypes.bool,
};

export const UITextLineProps = {
  truncate: false,
  withPadding: false,
};
